import api from "../api/axios";

const leadService = {
  // Lead listesi
  getAll: (searchTerm, status) => {
    let url = "lead";
    const params = new URLSearchParams();
    if (searchTerm) params.append("SearchTerm", searchTerm);
    if (status) params.append("Status", status);

    const queryString = params.toString();
    if (queryString) url += `?${queryString}`;

    return api.get(url);
  },

  // Lead ekle
  create: (data) => api.post("lead", data),

  // Lead güncelle
  update: (data) => api.put("lead", data),
};

export default leadService;
